export enum Personeria {
    Fisica = 'Fisica',
    Moral = 'Moral',
}
